import { render, staticRenderFns } from "./MyProjects.vue?vue&type=template&id=deca5586&scoped=true&"
import script from "./MyProjects.vue?vue&type=script&lang=ts&"
export * from "./MyProjects.vue?vue&type=script&lang=ts&"
import style0 from "./MyProjects.vue?vue&type=style&index=0&id=deca5586&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deca5586",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VProgressCircular,VRow})
